var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("address-layout", {
    staticClass: "align-items-end address-wrapper",
    class: _vm.containerClass,
    scopedSlots: _vm._u(
      [
        !_vm.ignoredFieldsFromRender["autocomplete"]
          ? {
              key: "autocomplete",
              fn: function () {
                return [
                  _c(
                    "material-input",
                    {
                      attrs: {
                        "validator-context": _vm.$v,
                        label: _vm.$t("global.doorr.addressLookup"),
                      },
                    },
                    [
                      _c("autocomplete-input", {
                        attrs: {
                          id: "autocomplete-address-" + _vm.uniqueId,
                          "class-name": _vm.lookupClass,
                          disabled: _vm.disabled,
                          tabindex: _vm.tabindex,
                          placeholder: _vm.$t("global.doorr.addressLookupType"),
                          "auto-fill": "off",
                          "auto-complete": "off",
                        },
                        on: { change: _vm.handleAddressAutocompleteChange },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          attrs: {
                            for: "autocomplete-address-" + _vm.uniqueId,
                            hidden: "",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("global.doorr.addressLookup")))]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["line1"]
          ? {
              key: "line1",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      "class-name": "line1",
                      value: _vm.localAddress["line1"]
                        ? _vm.localAddress["line1"]
                        : _vm.handleRenderLine1,
                      disabled: _vm.disabled,
                      name: "line1",
                      label: _vm.$t("global.doorr.addressLine1"),
                      tabindex: _vm.tabindex,
                      "max-length": _vm.maxLengthValidationsToUse["line1"],
                      "custom-expression": _vm.customExpressions["line1"],
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "line1")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["unit-number"]
          ? {
              key: "unit-number",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      value: _vm.localAddress["unit-number"],
                      "class-name": "unit_number",
                      disabled: _vm.disabled,
                      name: "unit-number",
                      label: _vm.$t("global.doorr.unitNumber"),
                      tabindex: _vm.tabindex,
                      "max-length": _vm.maxLengthValidationsToUse["unitNumber"],
                      "custom-expression": _vm.customExpressions["unitNumber"],
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "unit-number")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["street-number"]
          ? {
              key: "street-number",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      value: _vm.address["street-number"],
                      disabled: _vm.disabled,
                      name: "street-number",
                      type: "number",
                      label: _vm.$t("global.doorr.streetNumber"),
                      tabindex: _vm.tabindex,
                      "max-length":
                        _vm.maxLengthValidationsToUse["street-number"],
                      "custom-expression":
                        _vm.customExpressions["street-number"],
                      "class-name": "street_number",
                      "auto-fill": "off",
                      "auto-complete": "off",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "street-number")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["street-name"]
          ? {
              key: "street-name",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      value: _vm.address["street-name"],
                      disabled: _vm.disabled,
                      name: "street-name",
                      label: _vm.$t("global.doorr.streetName"),
                      tabindex: _vm.tabindex,
                      "max-length":
                        _vm.maxLengthValidationsToUse["street-name"],
                      "custom-expression": _vm.customExpressions["street-name"],
                      "class-name": "route",
                      "auto-fill": "off",
                      "auto-complete": "off",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "street-name")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["street-direction"]
          ? {
              key: "street-direction",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      value: _vm.localAddress["street-direction"],
                      "class-name": "street_direction",
                      disabled: _vm.disabled,
                      name: "street-direction",
                      label: _vm.$t("global.doorr.streetDirection"),
                      tabindex: _vm.tabindex,
                      "max-length":
                        _vm.maxLengthValidationsToUse["streetDirection"],
                      "custom-expression":
                        _vm.customExpressions["streetDirection"],
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "street-direction")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["line2"]
          ? {
              key: "line2",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      "class-name": "line2",
                      value: _vm.localAddress["line2"],
                      disabled: _vm.disabled,
                      name: "line2",
                      label: _vm.$t("global.doorr.addressLine2"),
                      tabindex: _vm.tabindex,
                      "max-length": _vm.maxLengthValidationsToUse["line2"],
                      "custom-expression": _vm.customExpressions["line2"],
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "line2")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["street-type"]
          ? {
              key: "street-type",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      "class-name": "street-type",
                      value: _vm.localAddress["street-type"],
                      disabled: _vm.disabled,
                      name: "street-type",
                      label: _vm.$t("global.doorr.streetType"),
                      tabindex: _vm.tabindex,
                      "max-length":
                        _vm.maxLengthValidationsToUse["street-type"],
                      "custom-expression": _vm.customExpressions["street-type"],
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "street-type")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["city"]
          ? {
              key: "city",
              fn: function () {
                return [
                  _c("material-input", {
                    attrs: {
                      "validator-context": _vm.$v,
                      value: _vm.localAddress["city"],
                      disabled: _vm.disabled,
                      name: "city",
                      label: _vm.$t("global.words.city"),
                      "class-name": "locality",
                      tabindex: _vm.tabindex,
                      "max-length": _vm.maxLengthValidationsToUse["city"],
                      "custom-expression": _vm.customExpressions["city"],
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "city")
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["province"]
          ? {
              key: "province",
              fn: function () {
                return [
                  _c(
                    "material-input",
                    {
                      attrs: {
                        "validator-context": _vm.$v,
                        label: _vm.$t("global.words.province"),
                        "custom-expression": _vm.customExpressions["province"],
                      },
                      model: {
                        value: _vm.localAddress["province"],
                        callback: function ($$v) {
                          _vm.$set(_vm.localAddress, "province", $$v)
                        },
                        expression: "localAddress['province']",
                      },
                    },
                    [
                      _c("select-input", {
                        staticClass: "administrative_area_level_1",
                        attrs: {
                          value: _vm.localAddress["province"],
                          disabled: _vm.disabled,
                          name: "province",
                          options: _vm.provinceOptions,
                          tabindex: _vm.tabindex,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleChange($event, "province")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        !_vm.ignoredFieldsFromRender["postal-code"]
          ? {
              key: "postal-code",
              fn: function () {
                return [
                  _c(
                    "material-input",
                    {
                      attrs: {
                        "validator-context": _vm.$v,
                        label: _vm.$t("global.doorr.postalCode"),
                        "label-for": "postal-code-label",
                        "custom-expression":
                          _vm.customExpressions["postal-code"],
                      },
                      model: {
                        value: _vm.localAddress["postal-code"],
                        callback: function ($$v) {
                          _vm.$set(_vm.localAddress, "postal-code", $$v)
                        },
                        expression: "localAddress['postal-code']",
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: {
                              mask: "a9a 9a9",
                              greedy: true,
                              showMaskOnHover: false,
                            },
                            expression:
                              "{ mask: 'a9a 9a9', greedy: true, showMaskOnHover: false }",
                          },
                        ],
                        staticClass:
                          "postal_code form-control forms-validation-deprecated",
                        class: {
                          "form-control-filled":
                            !!_vm.localAddress["postal-code"],
                        },
                        attrs: {
                          id: "postal-code-label-" + _vm.uniqueId,
                          disabled: _vm.disabled,
                          pattern:
                            "([A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]){0,1}",
                          maxlength: "7",
                          "data-parsley-error-message": _vm.$t(
                            "global.messages.invalidCanadianPostalCode"
                          ),
                          type: "text",
                          name: "postal-code",
                          tabindex: _vm.tabindex,
                        },
                        domProps: { value: _vm.localAddress["postal-code"] },
                        on: {
                          change: function ($event) {
                            return _vm.handleChange(
                              $event.target.value,
                              "postal-code"
                            )
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      attrs: {
                        for: "postal-code-label-" + _vm.uniqueId,
                        hidden: "",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.doorr.postalCode")))]
                  ),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }